import React from 'react'
import { Grid } from '@material-ui/core'
import Typography from '../../../../components/common/Typography'
import { Divider } from '../../../../components/common/Divider'
import Switch from '../../../../components/common/Inputs/Switch'
import CheckBox from '../../../../components/common/Inputs/CheckBox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { ReactComponent as IconVLetter } from '../../../../components/assests/ico-V-letter.svg'
import { ReactComponent as IconALetter } from '../../../../components/assests/ico-A-letter.svg'

export const renderSubmoduleRow = (column, checksOptions, optionTab, newUser, onToggleCheckbox) => {
  const userScope = newUser ? 'new-users' : 'existing-users'

  return (
    <Grid
      container
      item
      justifyContent="flex-start"
      xs={12}
      key={`tab-grid-checks-options-${optionTab}-${checksOptions.key}-${userScope}`}
      style={{ marginBottom: '0.6rem' }}
    >
      <Grid container item xs={2}>
        <FormControlLabel
          control={
            <CheckBox
              color="secondary"
              onChange={(ev) => onToggleCheckbox(ev, column, checksOptions, true)}
              checked={checksOptions.vCheckBox}
            />
          }
        />
      </Grid>

      <Grid item xs={10}>
        <FormControlLabel
          control={
            <CheckBox
              onChange={(ev) => onToggleCheckbox(ev, column, checksOptions, false)}
              color="secondary"
              checked={checksOptions.aCheckBox}
              disabled={!checksOptions.vCheckBox}
            />
          }
          label={checksOptions.name}
        />
      </Grid>
    </Grid>
  )
}

export const renderModuleColumn = ({
  column,
  optionTab,
  newUser,
  label,
  classes,
  onToggleModule,
  onToggleCheckbox,
}) => (
  <Grid item className={classes.moduleItem} key={`module-column-${optionTab}-${column.key}`}>
    <Grid container className={classes.moduleItemInner}>
      <div className={classes.moduleHeaderRow}>
        <div className={classes.moduleHeaderLeft}>
          <Typography className={classes.moduleTitle} variant="body2" title={label}>
            {label}
          </Typography>
        </div>

        <div className={classes.switchWrap}>
          <Switch
            checked={column.active}
            inputProps={{ 'aria-label': 'module' }}
            color="primary"
            onChange={(ev) => onToggleModule(ev, column)}
          />
        </div>
      </div>

      <Divider light spacing={2} xs={12} style={{ width: '100%' }} />

      <Grid container item justifyContent="flex-start" xs={12} spacing={0}>
        <Grid item xs={2}>
          <IconVLetter />
        </Grid>
        <Grid item xs={2}>
          <IconALetter />
        </Grid>
        <Grid item xs={8} />
      </Grid>

      {column.submodules.map((checksOptions) =>
        renderSubmoduleRow(column, checksOptions, optionTab, newUser, onToggleCheckbox)
      )}
    </Grid>
  </Grid>
)

export const renderModuleRow = ({
  rowModules,
  classes,
  optionTab,
  newUser,
  getLabel,
  onToggleModule,
  onToggleCheckbox,
}) => {
  if (!rowModules.length) return null

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignItems="stretch"
      spacing={3}
      className={classes.moduleRow}
    >
      {rowModules.map((column) =>
        renderModuleColumn({
          column,
          optionTab,
          newUser,
          label: getLabel(column),
          classes,
          onToggleModule,
          onToggleCheckbox,
        })
      )}
    </Grid>
  )
}
